export default {
  title: {
    id: 'bo_seller_customer_reviews_filters_mobile_title',
    defaultMessage: 'Filters',
  },
}
